import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import TrashIcon from "@/icons/TrashIcon";
import {
  classroomListCss,
  classRoomLabelCss,
  trashIconCss,
} from "./AssigneesList.style";

const propTypes = {
  /**
   * Array of classrooms to which content is assigned.
   */
  currentSelectionOfClassrooms: PropTypes.arrayOf({
    classroom: PropTypes.object,
  }),
  /**
   * Array of individual students to which content is assigned.
   */
  currentSelectionOfStudentAssignees: PropTypes.arrayOf({
    user: PropTypes.object,
  }),
  /**
   * setter fn for currentSelectionOfClassrooms, used to delete classes from list
   */
  setCurrentSelectionOfClassrooms: PropTypes.func,
  determineSmallGroupName: PropTypes.func,
};

/**
 * AssigneesList displays a list of classrooms, and provides
 * a delete button to modify the list of classrooms. Callbacks must
 * be provided to update the `assignees` array prop.
 */
const AssigneesList = ({
  currentSelectionOfClassrooms,
  currentSelectionOfStudentAssignees,
  setCurrentSelectionOfClassrooms,
  determineSmallGroupName,
}) => {
  const handleClassroomRemoval = (classroomId) => {
    const updatedClassroomSelections = currentSelectionOfClassrooms.filter(
      (selectedClassroom) => {
        return selectedClassroom?.id !== classroomId;
      },
    );

    // SelectedClassrooms must also be updated so that the modal
    // reflects the most up to date user selections.
    setCurrentSelectionOfClassrooms(updatedClassroomSelections);
  };

  // Should only have either classrooms or student assignees (for now), so separating into diverging blocks here.
  // Could be changed if future updates include ability to have both types of assignees.
  if (currentSelectionOfClassrooms.length) {
    return (
      <>
        <header css={classRoomLabelCss}>
          <label>CLASS NAME</label>
        </header>
        <ul css={classroomListCss}>
          {currentSelectionOfClassrooms?.map((assignedClassroom) => {
            return (
              <li key={assignedClassroom?.id}>
                <span>{assignedClassroom?.name}</span>
                <Button
                  ariaProps={{
                    "aria-label": `Remove ${assignedClassroom?.name}`,
                  }}
                  flavor={Button.flavors.incognito}
                  onClick={() => handleClassroomRemoval(assignedClassroom?.id)}
                >
                  <TrashIcon css={trashIconCss} />
                </Button>
              </li>
            );
          })}
        </ul>
      </>
    );
  } else if (currentSelectionOfStudentAssignees.length) {
    return (
      <>
        <ul css={classroomListCss}>
          <li key="sga-name">
            <span>
              {determineSmallGroupName(currentSelectionOfStudentAssignees)}
            </span>
          </li>
        </ul>
      </>
    );
  }
};

AssigneesList.propTypes = propTypes;

export default AssigneesList;
